<template>
    <div style="float: left">
        <div>
            <!-- 上传文件按钮 -->
            <a-upload
                v-if="type === 1"
                action="./api/jsaec/register/saveAttach"
                :headers="headers"
                :data="attach"
                :before-upload="beforeUpload"
                :show-upload-list="false"
                @change="handleChangeOfFile"
            >
                <a-button class="uploadBtn" v-if="btnType === 1" :loading="loading"> <a-icon type="upload" /> 上传文件 </a-button>
                <a v-else>上传</a>
            </a-upload>
            <!-- 上传文件文件名 -->
            <div v-else-if="type === 2">
                <div class="file-name">
                    <a-upload
                        action="./api/jsaec/register/saveAttach"
                        :headers="headers"
                        :data="attach"
                        :before-upload="beforeUpload"
                        :show-upload-list="false"
                        @change="handleChangeOfFile"
                    >
                        <a-tooltip :title="file.name">
                            <a>{{ file.name }}</a>
                        </a-tooltip>
                    </a-upload>
                </div>
                <div style="float: right"><a-icon v-if="file.name" style="color: #40a9ff" @click="handleRemove" type="delete" /></div>
            </div>

            <!-- 下载文件按钮 -->
            <a-tooltip v-else-if="file" :title="file.name">
                <div class="file-name longer">
                    <a @click="handleDownload">{{ file ? file.name : "" }} </a>
                </div>
            </a-tooltip>
        </div>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "UploadButton",
    props: {
        attachCfg: {
            type: Object,
            default: () => {}
        },
        state: {
            type: Number,
            default: 1
        },
        field: {
            type: String,
            default: ""
        },
        btnType: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            loading: false,
            attach: {},
            headers: {}, //上传请求头部
            file: {},
            isDelete: true,
            isReady: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        type() {
            if (!this.file && this.state === 1) {
                return 1;
            } else if (this.file && this.state === 1) {
                return 2;
            } else {
                return 3;
            }
        },
        queryParams: {
            get() {
                return {
                    fktable: this.attachCfg.fktable,
                    fkfield: this.field,
                    fkvalue: this.attachCfg.fkvalue,
                    isReady: this.isReady
                };
            }
        }
    },
    watch: {
        queryParams: {
            handler(newValue) {
                if (newValue.fkvalue) {
                    this.queryAttachFileList();
                }
            }
        }
    },
    created() {
        //this.headers.Authorization = `Bearer ` + this.getToken;
        this.isReady = true;
    },
    activated() {
        this.isReady = true;
    },
    methods: {
        queryAttachFileList() {
            this.file = {};
            this.loading = true;
            this.$FG_http
                .post(
                    "./api/jsaec/register/queryOneAttach",
                    {
                        queryParams: this.queryParams
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        if (data.data) {
                            this.file = data.data;
                        } else {
                            this.file = null;
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.$FG_message.error("P0002");
                    }
                });
        },
        beforeUpload(file) {
            this.loading = true;
            this.attachCfg.fkfield = this.field;
            this.attach.data = JSON.stringify(this.attachCfg);
            return true;
        },
        handleChangeOfFile(info) {
            if (info.file.status === "removed") {
                this.handleRemove();
            }
            if (info.file.status === "done") {
                //返回response
                this.loading = false;

                if (this.file) {
                    this.handleRemove();
                }
                this.queryAttachFileList();
            }
        },
        handleRemove(noShow) {
            this.loading = true;
            this.$FG_http
                .post(
                    "./api/jsaec/register/deleteAttach",
                    {
                        id: this.file.uid
                    },
                    { showSuccess: !noShow }
                )
                .then(({ success, data, errMsg }) => {
                    this.loading = false;
                    if (success) {
                        this.queryAttachFileList();
                    }
                });
        },
        handleDownload() {
            this.$FG_http
                .post(
                    "./api/jsaec/register/downloadAttach",
                    {
                        id: this.file.uid
                    },
                    {
                        responseType: "blob",
                        showSuccess: false,
                        timeout: 60000 * 60
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let aLink = document.createElement("a");
                        let blob = new Blob([data]);
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", this.file.name); // 设置下载文件名称
                        aLink.click(); //执行下载
                        document.body.appendChild(aLink);
                        URL.revokeObjectURL(aLink.href); //释放url
                        document.body.removeChild(aLink); //释放标签
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        }
    },
    beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.file-name {
    float: left;
    margin-right: 5px;
    width: 80px;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.margin {
    margin-top: 9px;
}
.longer {
    width: 120px;
}

.small-btn {
    position: absolute;
    font-size: 18px;
    padding: 75px;
    color: #fff;
    background: #000;
    opacity: 0.5;
}
</style>
